module.exports = __webpack_public_path__ + "img/reserve-shop-reservation.3fd64df7.png";